(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template-product-backup"]) return;
  try {
    
  let restocking = false;
  let productDate;
  try{
    productDate = document.querySelector('.js-productRestock');
    const [yearStr, monthStr, dayStr] = productDate.dataset.date.split('-');
    const todaysDate = new Date();
    const returningDate = new Date(yearStr, monthStr - 1, dayStr);
    if(returningDate > todaysDate) {
      restocking = true
    }
  }catch{}

  if(restocking) {
    productDate.classList.remove('d-none');
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-product"]) return;
  try {
    
  let restocking = false;
  let productDate;
  try{
    productDate = document.querySelector('.js-productRestock');
    const [yearStr, monthStr, dayStr] = productDate.dataset.date.split('-');
    const todaysDate = new Date();
    const returningDate = new Date(yearStr, monthStr - 1, dayStr);
    if(returningDate > todaysDate) {
      restocking = true
    }
  }catch{}

  if(restocking) {
    document.querySelectorAll('.js-productRestock').forEach(item => {
      item.classList.remove('d-none');
    })
  }


  } catch(e) { console.error(e); }
})();
})();
